import * as React from 'react'
import { withStyles, WithStyles, createStyles, InputAdornment } from '@zn-material-ui'
import Button from '@components/Button'

import Input from '@components/Input'
import { transform } from '@utils/intl_lang'
const styles = createStyles({
  captchaImg: {
    marginBottom: '20px !important',
    width: '145px !important',
    border: 'unset !important',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
})
interface IProps extends WithStyles<typeof styles> {
  captchaError: boolean
  captcha: string
  handleCaptchaChange: (event: any) => void
  handleUpdateCaptchaImg: () => void
  captchaUrl: string
}

const CaptchaInput: React.SFC<IProps> = ({
  classes,
  captchaError,
  captcha,
  handleCaptchaChange,
  handleUpdateCaptchaImg,
  captchaUrl,
}) => (
  <Input
    value={captcha}
    // "请输入右侧验证码"
    placeholder={transform('Login_enter_code')}
    onChange={handleCaptchaChange}
    showLabel={captchaError}
    // '验证码错误' : '验证码'
    label={
      captchaError ? transform('Login_code_error') : transform('Login_code')
    }
    endAdornment={
      <InputAdornment position="end">
        <Button
          defaultType={true}
          aria-label="captcha"
          className={classes.captchaImg}
          onClick={handleUpdateCaptchaImg}
          focusRipple={false}
          disableFocusRipple={true}
          disableRipple={true}
        >
          <img width={120} height={36} src={captchaUrl} />
        </Button>
      </InputAdornment>
    }
  />
)

export default withStyles(styles)(CaptchaInput)
